import SpecifierMapper from './specifier-mapper';

const SpecifierModel = {
    mapper: SpecifierMapper,

    name: {
        fieldName: 'n',
        type: String,
    },

    value: {
        fieldName: 'v',
        type: String,
    },
};

export default SpecifierModel;
